class TMAna {
    /**
     * @type {{
     *  host: string,
     *  customer: object,
     *  product: object,
     * }}
     */
    static config = JSON.parse(window.atob(window.hc_config));

    static trackPageView() {
        this.track('page_view');
    }

    static trackViewContent() {
        if (!this.config.product.variantId || !this.config.product.productId) {
            return;
        }

        this.track('view_content', {
            quantity: 1,
            variantId: this.config.product.variantId,
            parameters: this.productParameters(this.config.product.productId, this.config.product.price, 1),
            tiktokParameters: this.tiktokProductParameters(this.config.product.productId, this.config.product.price, 1),
        });
    }

    static trackAddToCart(item) {
        if (!item?.variantId || !item.productId || !item.quantity) {
            return;
        }

        this.track('add_to_cart', {
            variantId: item.variantId,
            quantity: item.quantity,
            parameters: this.productParameters(item.productId, item.price, item.quantity),
            tiktokParameters: this.tiktokProductParameters(item.productId, item.price, item.quantity),
        });
    }

    static track(event, { variantId = null, quantity = null, parameters = {}, tiktokParameters = null } = {}) {
        const uuid = crypto.randomUUID();
        this.trackMeta(event, uuid, { variantId, quantity, parameters });
        this.trackTikTok(event, uuid, { variantId, quantity, parameters: tiktokParameters });
    }

    static trackMeta(event, uuid, { variantId, quantity, parameters }) {
        const eventName = {
            page_view: 'PageView',
            add_to_cart: 'AddToCart',
            view_content: 'ViewContent',
        }[event];

        if (!eventName) {
            return;
        }

        window.fbq?.('track', eventName, parameters, { eventID: uuid });

        const eventEndpoint = `https://${this.config.host}/ev/m`;
        this.sendServerEvent(eventEndpoint, this.eventPayload(uuid, event, variantId, quantity, {
            fbc: this.getCookie('_fbc'),
            fbp: this.getCookie('_fbp'),
            clid: localStorage.getItem('sh_clid'),
        }));
    }

    static trackTikTok(event, uuid, { variantId, quantity, parameters }) {
        const eventName = {
            page_view: 'PageView',
            add_to_cart: 'AddToCart',
            view_content: 'ViewContent',
        }[event];

        if (!eventName) {
            return;
        }

        if (event === 'page_view') {
            window.ttq?.page({ event_id: uuid });
        } else if (parameters) {
            window.ttq?.track(eventName, { ...parameters, event_id: uuid });
        }

        const eventEndpoint = `https://${this.config.host}/ev/t`;
        this.sendServerEvent(eventEndpoint, this.eventPayload(uuid, event, variantId, quantity, {
            ttp: this.getCookie('_ttp'),
            ttclid: localStorage.getItem('sh_ttclid') ?? this.getCookie('ttclid'),
        }));
    }

    static eventPayload(uuid, event, variantId, quantity, attributions) {
        return JSON.stringify({
            uuid,
            event,
            url: window.location.href,
            variant_id: variantId,
            quantity,
            attributions,
            customer: this.config.customer,
        });
    }

    static persistIds() {
        const query = new URLSearchParams(window.location.search);

        const fbclid = query.get('fbclid');
        const ttclid = query.get('ttclid');

        if (ttclid) {
            localStorage.setItem('sh_ttclid', ttclid);
        }

        if (fbclid) {
            localStorage.setItem('sh_clid', fbclid);
        }

        const utmKeys = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_term', 'utm_content'];

        const sbParams = Object.fromEntries(
            utmKeys
                .map((key) => [key, query.get(key)])
                .filter(([, value]) => value),
        );

        if (Object.keys(sbParams).length) {
            localStorage.setItem('sh_params', JSON.stringify(sbParams));
        }
    }

    static sendServerEvent(eventEndpoint, payload) {
        void fetch(eventEndpoint, {
            method: 'POST',
            keepalive: true,
            headers: {
                Accept: 'application/json',
                'Content-Type': 'application/json',
            },
            body: payload,
        }).catch(() => {
            navigator.sendBeacon?.(eventEndpoint, new Blob([payload], { type: 'application/json' }));
        });
    }

    static productParameters(productId, price, quantity) {
        return {
            currency: 'BDT',
            content_type: 'product',
            value: price * quantity,
            content_ids: [String(productId)],
            contents: [{ id: String(productId), quantity, item_price: price }],
        };
    }

    static tiktokProductParameters(productId, price, quantity) {
        return {
            currency: 'BDT',
            content_type: 'product',
            value: price * quantity,
            content_ids: [String(productId)],
            contents: [{ content_id: String(productId), price, quantity }],
        };
    }

    static getCookie(name) {
        return document.cookie
            .split('; ')
            .find((cookie) => cookie.startsWith(`${name}=`))
            ?.split('=')
            .slice(1)
            .join('=') ?? null;
    }

}

window.TMAna = TMAna;

TMAna.persistIds();
TMAna.trackPageView();
TMAna.trackViewContent();
